import * as React from "react";
const FourDoorXLSize = ({ isActive = false }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={71}
    height={71}
    viewBox="0 0 71 71"
    fill={isActive ? "#292747" : "#9493A3"}
    className="gg-scale-[70%] gg-transition gg-duration-150 gg-ease-in-out sm:gg-scale-75 lg:gg-scale-[70%] xl:gg-scale-75 2xl:gg-scale-90"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M.5 0v55.43h70V0h-5.06v50.37H53V0h-3v50.37H37.5V0h-3v50.37h-13V0h-3v50.37H5.56V0z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M.146 67.354a.5.5 0 0 1 0-.707l3.182-3.182a.5.5 0 1 1 .708.707L1.707 66.5h67.586l-2.329-2.328a.5.5 0 1 1 .708-.707l3.182 3.182a.5.5 0 0 1 0 .707l-3.182 3.182a.5.5 0 1 1-.707-.707l2.328-2.329H1.707l2.329 2.329a.5.5 0 1 1-.708.707z"
      fill="#7F7D91"
    />
  </svg>
);
export default FourDoorXLSize;
